/* eslint-disable import/prefer-default-export */

// this file was created to move here the rest of functionalities' strings for improved clarity
const ENABLE_RIGHT_OF_WITHDRAWAL = "enable_right_of_withdrawal";

export { ENABLE_RIGHT_OF_WITHDRAWAL };
